import type { ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";
import { useDialogContentContext } from "./DialogContentContext";

const dialogFooterVariants = cva("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", {
  variants: {
    variant: {
      default: "border-t",
      floating:
        "absolute bottom-2 left-2 right-2 bg-background/95 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-background/80 animate-in slide-in-from-bottom-2 fade-in duration-200 shadow-md rounded-md border",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface DialogFooterProps extends ComponentProps<"div">, VariantProps<typeof dialogFooterVariants> {}

export const DialogFooter = ({ className, variant, ...props }: DialogFooterProps) => {
  const { divided } = useDialogContentContext();
  return (
    <div
      data-slot="dialog-footer"
      className={cn(
        dialogFooterVariants({ variant }),
        variant !== "floating" && divided && "px-6 py-4 [&:not(:first-child)]:border-t",
        className
      )}
      {...props}
    />
  );
};
